(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dfm-fulfillment-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dfm-fulfillment-status')) {
    customElements.define('dfm-fulfillment-status', class extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-dfm-variant-availability]');
        this.variants = data ? JSON.parse(data.textContent) : [];
        this.message = this.querySelector('[data-dfm-fulfillment-message]');
        this.note = this.querySelector('[data-dfm-fulfillment-note]');
        this.formRoot = this.closest('[data-product-form]');
        this.variantSelection = this.formRoot ? this.formRoot.querySelector('[data-variant-selection]') : null;

        if (this.variantSelection) {
          this.variantSelection.addEventListener('variant-change', event => {
            this.update(event.detail && event.detail.variant ? event.detail.variant : null);
          });
        }

        if (this.formRoot) {
          this.formRoot.addEventListener('change', event => {
            if (event.target.matches('[name="id"], [data-variants]')) {
              this.updateById(event.target.value);
            }
          });
        }
      }

      updateById(id) {
        const variant = this.variants.find(item => String(item.id) === String(id));
        this.update(variant || null);
      }

      update(variant) {
        if (!variant || !this.message) return;
        const available = Boolean(variant.available);
        const override = available ? this.dataset.inStockOverride : this.dataset.outOfStockOverride;
        const fallback = available ? this.dataset.inStockDefault : this.dataset.outOfStockDefault;
        this.message.textContent = override || fallback;
        if (this.note) this.note.hidden = !available;
        this.classList.toggle('is-available', available);
        this.classList.toggle('is-unavailable', !available);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dfm-sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dfm-sticky-cart')) {
    customElements.define('dfm-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        this.formRoot = this.closest('[data-product-form]');
        this.primaryButton = this.formRoot ? this.formRoot.querySelector('[data-add-to-cart-trigger]') : null;
        this.stickyButton = this.querySelector('[data-dfm-sticky-cart-button]');
        this.stickyLabel = this.querySelector('[data-dfm-sticky-cart-label]');
        this.stickyPrice = this.querySelector('[data-dfm-sticky-cart-price]');
        this.stickyVariant = this.querySelector('[data-dfm-sticky-cart-variant]');
        this.stickyStatus = this.querySelector('[data-dfm-sticky-cart-status]');
        this.variantSelection = this.formRoot ? this.formRoot.querySelector('[data-variant-selection]') : null;
        const variantData = this.querySelector('[data-dfm-sticky-cart-variants]');
        this.variants = variantData ? JSON.parse(variantData.textContent) : [];
        this.footerVisible = false;
        this.passedPrimaryButton = false;

        if (!this.primaryButton || !this.stickyButton || !this.stickyLabel) return;

        this.stickyButton.addEventListener('click', () => {
          if (!this.primaryButton.disabled) this.primaryButton.click();
        });

        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.primaryButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'data-label'],
          childList: true,
          subtree: true
        });

        if (this.variantSelection) {
          this.variantSelection.addEventListener('variant-change', event => {
            this.updateVariant(event.detail && event.detail.variant ? event.detail.variant : null);
          });
        }

        if (this.formRoot) {
          this.formRoot.addEventListener('change', event => {
            if (event.target.matches('[name="id"], [data-variants]')) {
              this.updateVariantById(event.target.value);
            }
          });
        }

        this.primaryObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.passedPrimaryButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.updateVisibility();
        });
        this.primaryObserver.observe(this.primaryButton);

        const footer = document.querySelector('footer, .footer');
        if (footer) {
          this.footerObserver = new IntersectionObserver(entries => {
            this.footerVisible = entries[0].isIntersecting;
            this.updateVisibility();
          });
          this.footerObserver.observe(footer);
        }

        this.syncButton();
        window.setTimeout(() => this.syncStatusFromForm(), 0);
      }

      disconnectedCallback() {
        if (this.buttonObserver) this.buttonObserver.disconnect();
        if (this.primaryObserver) this.primaryObserver.disconnect();
        if (this.footerObserver) this.footerObserver.disconnect();
        document.body.classList.remove('dfm-sticky-cart-visible');
      }

      syncButton() {
        const primaryLabel = this.primaryButton.querySelector('.text');
        const label = primaryLabel ? primaryLabel.textContent.trim() : this.primaryButton.textContent.trim();
        const disabled = this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true';
        if (label) this.stickyLabel.textContent = label;
        this.stickyButton.disabled = disabled;
        this.stickyButton.setAttribute('aria-disabled', String(disabled));
      }

      updateVariantById(id) {
        const variant = this.variants.find(item => String(item.id) === String(id));
        this.updateVariant(variant || null);
      }

      updateVariant(variant) {
        if (!variant) return;
        const storedVariant = this.variants.find(item => String(item.id) === String(variant.id));
        const currentVariant = storedVariant || variant;
        if (this.stickyPrice && currentVariant.price) this.stickyPrice.textContent = currentVariant.price;
        if (this.stickyVariant) {
          const title = currentVariant.title || '';
          this.stickyVariant.textContent = title;
          this.stickyVariant.hidden = !title || title === 'Default Title';
        }
        if (this.stickyStatus) {
          this.stickyStatus.textContent = currentVariant.available
            ? this.dataset.availableLabel
            : this.dataset.unavailableLabel;
        }
        window.setTimeout(() => {
          this.syncStatusFromForm();
          this.syncButton();
        }, 0);
      }

      syncStatusFromForm() {
        const fulfillmentMessage = this.formRoot.querySelector('[data-dfm-fulfillment-message]');
        if (this.stickyStatus && fulfillmentMessage && fulfillmentMessage.textContent.trim()) {
          this.stickyStatus.textContent = fulfillmentMessage.textContent.trim();
        }
      }

      updateVisibility() {
        this.hidden = !this.passedPrimaryButton || this.footerVisible;
        document.body.classList.toggle('dfm-sticky-cart-visible', !this.hidden);
        if (!this.hidden) this.dismissMobileChatPrompt();
      }

      dismissMobileChatPrompt() {
        if (!window.matchMedia('(max-width: 798px)').matches || this.chatPromptDismissed) return;
        const chatWidget = document.querySelector('dfm-chat-widget, .dfm-chat-widget, #dfm-chat-widget');
        const chatRoot = chatWidget && chatWidget.shadowRoot ? chatWidget.shadowRoot : document;
        const closeButton = chatRoot.querySelector('#dfm-teaser-close');
        const teaser = chatRoot.querySelector('.dfm-teaser');
        if (closeButton) {
          closeButton.click();
          this.chatPromptDismissed = true;
        } else if (teaser) {
          teaser.style.setProperty('display', 'none', 'important');
          this.chatPromptDismissed = true;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
